/**
 * Path regexes shared by Sentry API error ignore rules.
 * Keep route matchers here so ignore predicates stay readable and consistent.
 */

/** Custom categories API tree (url_routes / custom_category_routes). */
export const CUSTOM_CATEGORIES_PATH = /\/custom_categories(?:\/|$)/

/** Session refresh (refresh_tokens lambda). */
export const REFRESH_TOKEN_PATH = /\/refresh-tokens\/?$/

/** Login callback / switch-account token exchange (get_tokens lambda). */
export const GET_TOKENS_PATH = /\/get-tokens\/?$/

/**
 * CASB provider file live-info (getCASBFileLiveInfo).
 * Google/Microsoft upstream 500s are not actionable frontend defects.
 */
export const CASB_PROVIDER_FILE_LIVE_PATH =
  /\/neural\/dlp\/(google|microsoft)\/files\/[^/]+\/live\/?$/
